import { useTranslation } from 'react-i18next';

import { Tag } from '~/components';
import { cn } from '~/lib/cn';

import { ArtistFilterTagTooltip } from '../../ArtistFilterTagTooltip';
import { SELECTED_TAG_CLASSES } from '../constants';

interface ArtistCrossoverFilterProps {
  isCrossoverFilterSelected: boolean;
  onSelect: (isCrossover: boolean) => void;
}

export const ArtistCrossoverFilter = ({
  isCrossoverFilterSelected,
  onSelect,
}: ArtistCrossoverFilterProps) => {
  const { t } = useTranslation('roster');

  return (
    <div className="flex gap-sm py-sm">
      <Tag
        asChild
        variant="secondary"
        className={cn({
          [SELECTED_TAG_CLASSES]: !isCrossoverFilterSelected,
        })}
        onClick={() => {
          onSelect(false);
        }}
      >
        <button>{t('all.label')}</button>
      </Tag>
      <Tag
        asChild
        variant="secondary"
        className={cn({
          [SELECTED_TAG_CLASSES]: isCrossoverFilterSelected,
        })}
        onClick={() => {
          onSelect(!isCrossoverFilterSelected);
        }}
      >
        <button>
          {t('crossover.label')}
          <ArtistFilterTagTooltip
            trans={{
              i18nKey: 'crossover.tooltip',
            }}
          />
        </button>
      </Tag>
    </div>
  );
};

ArtistCrossoverFilter.displayName = 'ArtistCrossoverFilter';
